import "./LoginLayout.scss";
import React, { FC, PropsWithChildren } from "react";

import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { usePartnerInfo } from "@utils";

import { Box, Button, Icon, ImageComponent, Link, Text } from "@ui/elements";
import { Stack } from "@ui/layout";

import { LanguageSelect } from "../LanguageSelect/LanguageSelect";

export const LoginLayout: FC<PropsWithChildren> = () => {
  const { t } = useTranslation();
  const partnerInfo = usePartnerInfo();

  return (
    <div className="login-layout">
      <div className="login-layout-language-select">
        <LanguageSelect />
      </div>
      <a className="login-layout__logo" href="/login">
        <ImageComponent size={128} src={partnerInfo.logo.square} />
      </a>
      <div className="login-layout__content">
        <Box className="login-layout__box">
          <Outlet />
        </Box>
      </div>

      <Stack
        align="center"
        direction="column"
        className="login-layout__box-help"
      >
        <Text size="small">{t("do-you-need-help")}</Text>
        <Stack justify="center">
          {partnerInfo.contact.telegram && (
            <Button
              variant="light"
              isRounded
              as="link"
              href={partnerInfo.contact.telegram}
              target="_blank"
            >
              <Icon icon="TelegramLogo" />
            </Button>
          )}
          {partnerInfo.contact.whatsapp && (
            <Button
              variant="light"
              isRounded
              as="link"
              href={partnerInfo.contact.whatsapp}
              target="_blank"
            >
              <Icon icon="WhatsappLogo" />
            </Button>
          )}
          {partnerInfo.contact.facebook && (
            <Button
              variant="light"
              isRounded
              as="link"
              href={partnerInfo.contact.facebook}
              target="_blank"
            >
              <Icon icon="FacebookLogo" />
            </Button>
          )}
          {partnerInfo.contact.tiktok && (
            <Button
              variant="light"
              isRounded
              as="link"
              href={partnerInfo.contact.tiktok}
              target="_blank"
            >
              <Icon icon="TiktokLogo" />
            </Button>
          )}
          {partnerInfo.contact.instagram && (
            <Button
              variant="light"
              isRounded
              as="link"
              href={partnerInfo.contact.instagram}
              target="_blank"
            >
              <Icon icon="InstagramLogo" />
            </Button>
          )}
          {partnerInfo.contact.email && (
            <Button
              variant="light"
              isRounded
              as="link"
              href={`mailto:${partnerInfo.contact.email}`}
              target="_blank"
            >
              <Icon icon="At" />
            </Button>
          )}
        </Stack>
      </Stack>
      <Stack
        direction="column"
        className="login-layout__legals"
        justify="center"
        align="center"
      >
        <Stack justify="center">
          <Link target="_blank" href="/terms-and-conditions" size="small">
            {t("terms-and-conditions")}
          </Link>
          <Link target="_blank" href="/privacy-policy" size="small">
            {t("privacy-policy")}
          </Link>
          <Link target="_blank" href="/disclaimer" size="small">
            {t("disclaimer")}
          </Link>
          <Link target="_blank" href="/cookies" size="small">
            {t("cookie-policy")}
          </Link>
        </Stack>
        <Text
          variant="secondary"
          size="small"
          dangerouslySetInnerHTML={{ __html: t("recaptchaInfo") }}
        />
      </Stack>
    </div>
  );
};
